<template>
  <div id="ImportXmlNfeStep">
    <v-card elevation="1" class="pa-1 pt-0">
      <div class="d-flex pa-2 pt-1 list-container">
        <v-card class="column pa-1">
          <div class="d-flex justify-space-between align-center column-title px-3">
            <div class="d-flex align-center">
              <h1 style="color: black">NFes não utilizadas</h1>
              <v-divider v-show="!isCollapsed" vertical class="mx-2 my-1"></v-divider>
              <span v-show="!isCollapsed" class="mb-0 mt-1 font-weight-medium caption mr-2"
                >{{ filteredUnusedNfes.length }} itens</span
              >
              <v-tooltip right nudge-top="1">
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-checkbox
                      v-if="!isCollapsed"
                      v-model="selectAllUnusedNfes"
                      :disabled="disabledSelectAll"
                      class="custom-checkbox pa-0 ma-0"
                      hide-details
                      @change="toggleSelectAllUnused"
                    ></v-checkbox>
                  </div>
                </template>
                <span>Selecionar todas</span>
              </v-tooltip>
            </div>
            <div class="d-flex align-center">
              <span v-if="unusedNfes.length > 0">
                <v-tooltip v-if="!isCollapsed" right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" class="ml-3" @click="isCollapsed = !isCollapsed"
                      >mdi-chevron-double-left</v-icon
                    >
                  </template>
                  <span>Recolher</span>
                </v-tooltip>
                <v-tooltip v-else right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="isCollapsed = !isCollapsed">
                      mdi-chevron-double-right
                    </v-icon>
                  </template>
                  <span>Expandir</span>
                </v-tooltip>
              </span>
            </div>
          </div>
          <div v-if="isCollapsed" class="d-flex justify-space-between align-center px-3">
            <v-checkbox
              v-model="selectAllUnusedNfes"
              :disabled="disabledSelectAll"
              label="Selecionar todas"
              class="custom-checkbox collapsed pa-0 ma-0"
              hide-details
              @change="toggleSelectAllUnused"
            ></v-checkbox>
            <v-divider vertical class="mx-1 my-1"></v-divider>
            <span class="mb-0 font-weight-medium caption">{{ filteredUnusedNfes.length }} itens</span>
          </div>
          <v-divider class="mx-2 my-1"></v-divider>
          <v-text-field
            v-show="!isCollapsed"
            class="custom-search px-2"
            label="Buscar"
            color="black"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            single-line
            v-model="searchQuery"
            @keydown.enter="filterNfes()"
            @click:prepend-inner="filterNfes()"
          ></v-text-field>
          <div v-if="isUnallocatedLoading" class="px-2">
            <v-progress-linear indeterminate />
          </div>
          <div
            class="nfes-container pa-2"
            :style="{ height: isCollapsed ? '540px' : '530px', width: isCollapsed ? '240px' : '370px' }"
          >
            <nfe-card
              v-for="nfe in virtualUnusedNfesList"
              :selected="selectedNfe[nfe.id]"
              :isCollapsed="isCollapsed"
              :unallocatedNfe="nfe"
              :isDragable="false"
              :isDelete="true"
              :key="nfe.id"
              @update:selected="updateUnusedSelection(nfe.id, $event)"
              @openDialogDelete="openDelete"
            />
            <div v-if="filteredUnusedNfes.length" v-observe-visibility="handleUnusedNfeScroll"></div>
            <div v-if="filteredUnusedNfes.length == 0" class="d-flex justify-center align-center py-3">
              Nenhuma NFe encontrada
            </div>
          </div>
        </v-card>
        <v-card class="column w-100 ml-3" style="box-shadow: none">
          <v-card-text class="list-container table-container pa-0 pb-1 px-2">
            <div
              class="selected-container d-flex align-center justify-center rounded mb-2"
              @click="isUploadDialogOpen = true"
            >
              <h4 class="text-center align-center font-weight-regular">
                <v-icon size="20" color="" style="padding-bottom: 3px">mdi-plus-box-outline</v-icon>
                <a class="new-import-nfe text-decoration-underline" target="_blank" rel="noopener noreferrer">
                  Clique aqui para importar novas NFes.
                </a>
              </h4>
            </div>

            <div class="card-container py-2">
              <div
                v-for="(card, index) in filteredCardStatus"
                :key="card.id"
                :class="[
                  'v-card-text-nfe',
                  'align-center',
                  'rounded',
                  'pa-2',
                  { 'selected-card': selectedCard === index }
                ]"
                @click="selectCardStatus(index, card)"
              >
                <v-row class="align-center">
                  <v-col cols="auto">
                    <h4>{{ card.count }}</h4>
                  </v-col>
                  <v-col cols="auto" class="px-0">{{ card.label }}</v-col>
                  <v-col cols="auto">
                    <Futter class="v-icon" />
                  </v-col>
                </v-row>
              </div>
            </div>
            <v-card>
              <v-data-table
                :headers="fileHeaders"
                :items="getXmlsNfe"
                :loading="isImportsLoading"
                :items-per-page="paginate.pageSize"
                @update:items-per-page="changeItemsPerPage"
                :footer-props="{
                  'items-per-page-options': [7, 10, 20, 30, 50],
                  itemsPerPageText: 'Itens por página'
                }"
                no-data-text="Nenhum arquivo selecionado"
              >
                <template v-if="getXmlsNfe.length > 0" v-slot:[`header.select`]="{}">
                  <v-checkbox
                    v-show="canSelectAllXmlNfe"
                    hide-details
                    v-model="selectAllXmlNfe"
                    class="pa-0 ma-0 ml-6"
                    @change="toggleSelectAllXmls"
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.select`]="{ item }">
                  <v-checkbox
                    v-if="item.statusName !== 'Processando'"
                    hide-details
                    v-model="selectedXmlNfe[item.id]"
                    @change="updateSelectXml(item.id, $event)"
                    class="pa-0 ma-0 ml-6"
                  ></v-checkbox>
                </template>
                <template v-slot:[`item.statusName`]="{ item }">
                  <span v-if="item.statusName === 'Importado com sucesso'" class="green--text">
                    {{ item.statusName }}
                  </span>
                  <span v-else-if="item.statusName === 'Processando'" class="orange--text">
                    {{ item.statusName }}
                  </span>
                  <span v-else-if="item.statusName === 'NFE já importada com processo'" class="red--text">
                    {{ item.statusName }} {{ item?.errorsJson[0]?.errors[0] }}
                  </span>
                  <span v-else class="red--text">
                    {{
                      item.statusName != 'Erro na importação' && item.statusName != 'NFE já importada com processo'
                        ? `Erro na importação - ${item.statusName}`
                        : item.statusName
                    }}
                  </span>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <div v-if="item.statusName !== 'Processando'" class="d-flex align-center">
                    <div
                      class="d-flex"
                      v-if="
                        item.statusName !== 'NFE já importada com processo' &&
                        item?.errorsJson &&
                        item.errorsJson.length
                      "
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <ViewSVG v-bind="attrs" v-on="on" @click="openDetailsDialog(item)" />
                        </template>
                        <span> Detalhes dos Erros </span>
                      </v-tooltip>
                    </div>
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon color="red" @click.stop.prevent="openDelete(item)" dark>
                          <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Descartar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <v-pagination v-model="page" :length="paginate.totalPages" :total-visible="7"></v-pagination>
            </v-card>
          </v-card-text>
        </v-card>
      </div>
    </v-card>
    <upload-xml-nfe :isOpen.sync="isUploadDialogOpen" @shouldUpdateList="shouldUpdateList" />
    <confirm-dialog
      :isOpen.sync="isDeleteConfirmOpen"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      title="Deletar Nfes"
      :body-text="confirmationDeleteText"
      @confirmClick="handleDeleteImportNfe"
      @cancelClick="$emit('cancelClick')"
    />
    <confirm-dialog
      :isOpen.sync="isOpenConfirmationComputed"
      :isConfirmBtnLoading="isDeleteButtonLoading"
      title="Importação de NFes"
      :body-text="confirmationText"
      @confirmClick="$emit('confirmClick', selectedNfeIds), (selectedNfeNumbers = [])"
      @cancelClick="$emit('cancelClick')"
    />
    <MessagesError :errors="errors" :type="errorsType" :error500="error500" @closeMessages="errors = []" />
    <import-xml-nfe-details
      :isOpen.sync="isDetailsDialogOpen"
      :nfeXml="nfeXmlDetails"
      @update:isOpen="isDetailsDialogOpen = false"
    />
  </div>
</template>

<script>
import ImportXmlNfeDetails from '@/components/ManualBoardingImport/Stepper/ImportXmlNfeDetails.vue';
import UploadXmlNfe from '@/components/ManualBoardingImport/Stepper/Step1/UploadXmlNfeDialog.vue';
import NfeCard from '@/components/ManualBoardingImport/Stepper/NfeCard.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import MessagesError from '@/components/MessagesError.vue';
import { mapActions, mapState, mapMutations } from 'vuex';
import maskWeight from '@/utils/maskWeight';
import maskCNPJ from '@/utils/maskCNPJ';
import maskCPF from '@/utils/maskCPF';
import Futter from '@/assets/img/futter.svg';
import ViewSVG from '@/assets/img/view.svg';

export default {
  name: 'ImportsXmlNfeStep',
  components: {
    NfeCard,
    UploadXmlNfe,
    MessagesError,
    ConfirmDialog,
    ImportXmlNfeDetails,
    Futter,
    ViewSVG
  },
  props: {
    isOpenConfirmation: {
      type: Boolean,
      default: false
    },
    isBatchDeleteDialogOpen: {
      type: Boolean,
      default: false
    },
    totalNfes: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    isUnallocatedLoading: false,
    isImportsLoading: false,
    isDetailsDialogOpen: false,
    nfeXmlDetails: {},
    isDeleteButtonLoading: false,
    selectedCard: 0,
    filterByCardStatus: [
      { count: 0, label: 'Arquivos importados', status: 'importedFiles' },
      {
        count: 0,
        label: 'Importações em Processo',
        status: 'importsInProcess',
        id: 'dae2a2c5-e103-433f-808a-cc5f8d67d238'
      },
      { count: 0, label: 'Erros de Importação', status: 'importError', id: '8cb5df6f-da1e-4ed5-aeff-230e895f5bb6' },
      {
        count: 0,
        label: 'Importações com Sucesso',
        status: 'successfulImports',
        id: 'efd7826e-e7d4-44ce-899b-22654dcaa492'
      }
    ],
    fileHeaders: [
      {
        value: 'select',
        text: '',
        sortable: false
      },
      {
        value: 'number',
        text: 'NÚMERO NFE',
        sortable: true
      },
      {
        value: 'accessKey',
        text: 'CHAVE DE ACESSO',
        sortable: true
      },
      {
        value: 'statusName',
        text: 'STATUS',
        sortable: true
      },
      {
        value: 'actions',

        text: 'AÇÕES',
        sortable: false
      }
    ],
    unusedNfes: [],
    filteredUnusedNfes: [],
    selectAllUnusedNfes: false,
    selectAllXmlNfe: false,
    searchQuery: '',
    unusedNfesToShow: 10,
    isCollapsed: true,
    isUploadDialogOpen: false,
    isDeleteConfirmOpen: false,
    trashItem: {},
    trashXml: true,
    errors: [],
    errorsType: 'error',
    error500: null,
    selectedNfe: {},
    selectedXmlNfe: {},
    getXmlsNfe: [],
    selectedNfeNumbers: []
  }),
  async mounted() {
    await this.fetchUnusedNfes();
    this.setItemPerPage(7);
    await this.fetchAllXmlNfe();
    await this.fetchQuantityXmlsNfe();
    this.checkAndEmit();
    this.checkBatchDelete();
    const importsInProcess = this.filterByCardStatus.find((item) => item.status === 'importsInProcess');
    if (importsInProcess && importsInProcess.count > 0) {
      this.startPolling();
    }
  },
  computed: {
    ...mapState('ImportManualNfeStore', ['paginate']),
    page: {
      get() {
        return this.paginate.pageNumber;
      },
      set(value) {
        this.setPageNumber(value);
        this.fetchAllXmlNfe().then(() => {
          this.toggleSelectAllXmls();
        });
      }
    },
    isOpenConfirmationComputed: {
      get() {
        return this.isOpenConfirmation;
      },
      set(value) {
        this.$emit('update:isOpenConfirmation', value);
      }
    },
    totalNfesImport() {
      return (
        this.filterByCardStatus.find((item) => item.status === 'successfulImports').count +
        this.selectedNfeIds.length -
        this.totalNfes
      );
    },
    confirmationText() {
      if (this.getErrorNfeCount) {
        return `Algumas NFe(s) têm falhas de importação e não serão importadas. Deseja descartá-las e importar as ${
          this.totalNfesImport
        } Nfes restante${this.totalNfesImport > 1 ? 's' : ''}?`;
      } else {
        return this.totalNfesImport > 0
          ? `Confirmar importação das ${this.totalNfesImport} NFes?`
          : 'Nenhuma nova importação de Nfe. Deseja Prosseguir? ';
      }
    },
    confirmationDeleteText() {
      let nfeNames;
      if (this.isBatchDeleteDialogOpen) {
        nfeNames = this.selectedNfeNumbers;
        return `Deseja excluir as NFes selecionadas: ${nfeNames.slice(0, 15)}${nfeNames.length > 15 ? '...' : ''}?`;
      } else if (this.trashItem && this.trashItem.number) {
        nfeNames = this.trashItem.number;
        return `Deseja excluir a NFe: ${nfeNames}?`;
      } else {
        return 'Nenhuma NFe selecionada para exclusão.';
      }
    },
    virtualUnusedNfesList() {
      return this.filteredUnusedNfes.slice(0, this.unusedNfesToShow);
    },
    canSelectAllXmlNfe() {
      return this.getXmlsNfe.some((item) => item.statusName !== 'Processando');
    },
    getErrorNfeCount() {
      return this.filterByCardStatus.find((item) => item.status === 'importError').count;
    },
    parameterID() {
      return this.$route.params.id;
    },
    disabledSelectAll() {
      return this.filteredUnusedNfes.length === 0;
    },
    selectedNfeIds() {
      return Object.keys(this.selectedNfe).filter((id) => this.selectedNfe[id]);
    },
    selectedXmlNfeIds() {
      return Object.keys(this.selectedXmlNfe).filter((id) => this.selectedXmlNfe[id]);
    },
    filteredCardStatus() {
      return this.filterByCardStatus.filter((item) => item.count > 0);
    }
  },
  watch: {
    isBatchDeleteDialogOpen: {
      handler() {
        this.isDeleteConfirmOpen = this.isBatchDeleteDialogOpen;
      }
    },
    searchQuery: {
      handler(value) {
        if (value === '') {
          this.filteredUnusedNfes = this.unusedNfes;
        }
      }
    },
    filteredUnusedNfes: {
      handler() {
        this.selectAllUnusedNfes ? this.toggleSelectAllUnused() : this.updateSelectAllUnused();
      }
    }
  },
  methods: {
    ...mapMutations('ImportManualNfeStore', ['setItemPerPage', 'setPageNumber', 'setFilterStatusId']),
    ...mapActions('ImportManualNfeStore', [
      'getAllXmlsNfe',
      'getUnusedNfes',
      'deleteXmlNfe',
      'deleteUnusedNfes',
      'getQuantityXmlsNfeStatus'
    ]),

    async shouldUpdateList() {
      await this.fetchAllXmlNfe();
      await this.fetchQuantityXmlsNfe();

      const importsInProcess = this.filterByCardStatus.find((item) => item.status === 'importsInProcess');

      if (importsInProcess && importsInProcess.count > 0) {
        this.startPolling();
      } else {
        this.checkAndEmit();
      }
    },
    isProcessing(item) {
      return item.statusName === 'Processando';
    },
    async fetchAllXmlNfe(relaoder = false) {
      this.isImportsLoading = true;
      try {
        this.getXmlsNfe = await this.getAllXmlsNfe(this.parameterID);
      } catch (err) {
        console.error(err);
      } finally {
        if (!relaoder) {
          this.isImportsLoading = false;
        }
      }
    },
    async fetchUnusedNfes() {
      this.isUnallocatedLoading = true;
      try {
        const data = await this.getUnusedNfes();
        this.unusedNfes = data;
        this.filteredUnusedNfes = data;
      } catch (err) {
        console.error(err);
      } finally {
        this.isUnallocatedLoading = false;
      }
    },
    async fetchQuantityXmlsNfe() {
      this.isImportsLoading = true;
      try {
        const data = await this.getQuantityXmlsNfeStatus(this.parameterID);

        const statusMap = {
          importedFiles: data.importedFiles,
          importsInProcess: data.importsInProcess,
          importError: data.importError,
          successfulImports: data.successfulImports
        };

        this.filterByCardStatus = this.filterByCardStatus.map((card) => {
          if (statusMap[card.status] !== undefined) {
            card.count = statusMap[card.status];
          }
          return card;
        });
      } catch (err) {
        console.error(err);
      } finally {
        this.isImportsLoading = false;
      }
    },
    filterNfes() {
      this.isUnallocatedLoading = true;
      const query = this.searchQuery ? this.searchQuery.toLowerCase() : '';
      const queryNormalized = query.replace(/[^\d]/g, '');
      if (query === '') {
        this.filteredUnusedNfes = this.unusedNfes;
      } else {
        const normalizeValue = (value) => (value ? value.replace(/[^\d]/g, '') : '');
        this.filteredUnusedNfes = this.unusedNfes.filter((nfe) => {
          return (
            (nfe.number && nfe.number.toString().toLowerCase().includes(query)) ||
            (nfe.accessKey && nfe.accessKey.toString().toLowerCase().includes(query)) ||
            (nfe.nameSender && nfe.nameSender.toLowerCase().includes(query)) ||
            (nfe.cpfCnpjSender && this.transformCpfOrCnpj(nfe.cpfCnpjSender).toLowerCase().includes(query)) ||
            (nfe.nameRecipient && nfe.nameRecipient.toLowerCase().includes(query)) ||
            (nfe.cpfCnpjRecipient && this.transformCpfOrCnpj(nfe.cpfCnpjRecipient).toLowerCase().includes(query)) ||
            (nfe.price && queryNormalized && normalizeValue(maskWeight(nfe.price)).includes(queryNormalized)) || // Ensure queryNormalized is not empty
            (nfe.weight && `${maskWeight(nfe.weight)}kg`.toLowerCase().includes(query))
          );
        });
      }
      this.isUnallocatedLoading = false;
    },
    handleUnusedNfeScroll(isVisible) {
      if (!isVisible || this.unusedNfesToShow >= this.filteredUnusedNfes.length) return;
      this.unusedNfesToShow += 5;
    },
    startPolling() {
      const checkAndUpdate = async () => {
        this.isImportsLoading = true;
        await this.fetchAllXmlNfe(true);
        await this.fetchQuantityXmlsNfe();

        const importsInProcess = this.filterByCardStatus.find((item) => item.status === 'importsInProcess');

        if (importsInProcess && importsInProcess.count > 0) {
          setTimeout(checkAndUpdate, 2000);
        } else {
          this.checkAndEmit();
        }
        this.isImportsLoading = false;
      };

      checkAndUpdate();
    },
    openDetailsDialog(nfeXmlDetails) {
      this.nfeXmlDetails = nfeXmlDetails;
      this.isDetailsDialogOpen = true;
    },
    async changeItemsPerPage(items) {
      this.setItemPerPage(items);
      this.fetchAllXmlNfe();
      this.toggleSelectAllXmls();
    },
    toggleSelectAllXmls() {
      if (this.canSelectAllXmlNfe) {
        this.getXmlsNfe.forEach((nfe) => {
          if (nfe.statusName !== 'Processando') {
            this.$set(this.selectedXmlNfe, nfe.id, this.selectAllXmlNfe);
            const nfeNumber = nfe.number;

            if (this.selectAllXmlNfe && !this.selectedNfeNumbers.includes(nfeNumber)) {
              this.selectedNfeNumbers.push(nfeNumber);
            } else if (!this.selectAllXmlNfe && this.selectedNfeNumbers.includes(nfeNumber)) {
              this.selectedNfeNumbers = this.selectedNfeNumbers.filter((number) => number !== nfeNumber);
            }
          }
        });
      }
      if (!this.selectAllXmlNfe) {
        this.selectedNfeNumbers = this.selectedNfeNumbers.filter(
          (number) => !this.getXmlsNfe.some((nfe) => nfe.number === number)
        );
        this.selectedXmlNfe = {};
      }
      this.checkBatchDelete();
    },
    updateSelectXml(nfeId, value) {
      this.$set(this.selectedXmlNfe, nfeId, value);
      const nfeNumber = this.getXmlsNfe.find((nfe) => nfe.id === nfeId)?.number;

      if (value && nfeNumber) {
        this.selectedNfeNumbers.push(nfeNumber);
      } else {
        this.selectedNfeNumbers = this.selectedNfeNumbers.filter((number) => number !== nfeNumber);
      }

      if (!value) {
        this.selectAllXmlNfe = false;
      } else {
        const totalSelectableNfes = this.getXmlsNfe.filter((nfe) => nfe.statusName !== 'Processando').length;
        const selectedCount = Object.keys(this.selectedXmlNfe).filter((id) => this.selectedXmlNfe[id]).length;
        if (totalSelectableNfes > 0 && selectedCount === totalSelectableNfes) {
          this.selectAllXmlNfe = true;
        }
      }
      this.checkAndEmit();
      this.checkBatchDelete();
    },
    toggleSelectAllUnused() {
      this.selectedNfe = {};
      this.filteredUnusedNfes.forEach((nfe) => {
        this.$set(this.selectedNfe, nfe.id, this.selectAllUnusedNfes);
      });
      if (this.selectAllUnusedNfes) {
        this.selectedNfeNumbers = this.filteredUnusedNfes.map((nfe) => nfe.number);
      } else {
        this.selectedNfeNumbers = this.selectedNfeNumbers.filter(
          (number) => !this.filteredUnusedNfes.some((nfe) => nfe.number === number)
        );
      }
      this.updateSelectAllUnused();
    },
    updateSelectAllUnused() {
      this.selectAllUnusedNfes = this.filteredUnusedNfes.every((nfe) => this.selectedNfe[nfe.id]);
      this.checkAndEmit();
      this.checkBatchDelete();
    },
    updateUnusedSelection(nfeId, value) {
      this.$set(this.selectedNfe, nfeId, value);
      const nfe = this.filteredUnusedNfes.find((nfe) => nfe.id === nfeId);
      if (!value) {
        this.selectAllUnusedNfes = false;
        this.selectedNfeNumbers.splice(this.selectedNfeNumbers.indexOf(nfe.number), 1);
      } else {
        this.selectedNfeNumbers.push(nfe.number);
      }
      this.updateSelectAllUnused();
    },
    async openDelete(item, trashXml = true) {
      this.trashXml = trashXml;
      this.trashItem = item;
      this.isDeleteConfirmOpen = true;
    },
    async handleDeleteImportNfe() {
      this.isDeleteButtonLoading = true;
      try {
        let nfeIds = [];
        let xmlIds = [];
        if (this.isBatchDeleteDialogOpen) {
          xmlIds = this.selectedXmlNfeIds;
          nfeIds = this.selectedNfeIds;
        } else {
          if (this.trashXml) {
            xmlIds = [this.trashItem.id];
          } else {
            nfeIds = [this.trashItem.id];
          }
        }
        let response;

        if (nfeIds.length > 0 && xmlIds.length > 0) {
          response = await this.deleteXmlNfe(xmlIds);
          let responseTWO = await this.deleteUnusedNfes(nfeIds);

          if (response.success && responseTWO.success) {
            this.errors = ['NFes e XMLs deletados com sucesso!'];
            this.errorsType = 'success';
            this.selectedXmlNfe = {};
            this.selectedNfe = {};
            this.selectAllXmlNfe = false;
            this.selectAllUnusedNfes = false;
            await this.fetchUnusedNfes();
            await this.fetchAllXmlNfe();
          } else if (response.success && !responseTWO.success) {
            this.errors =
              `XMLs deletados com sucesso, mas houve erro ao deletar NFes não utilizadas::\n ${responseTWO.errors}` || [
                'Erro ao deletar Nfes'
              ];
            this.errorsType = 'info';
            this.selectedXmlNfe = {};
          } else if (!response.success && responseTWO.success) {
            this.errors = [
              'NFes não utilizadas deletadas com sucesso, mas houve erro ao deletar XMLs:',
              response.errors
            ];
            this.errorsType = 'info';
            this.selectAllUnusedNfes = false;
            this.selectedNfe = {};
            await this.fetchUnusedNfes();
          } else {
            this.errors = ['Erro ao deletar NFes e XMLs:', response.errors, responseTWO.errors];
            this.errorsType = 'error';
          }
        } else if (nfeIds.length > 0) {
          response = await this.deleteUnusedNfes(nfeIds);

          if (response.success) {
            this.errors = ['NFes deletados com sucesso!'];
            this.errorsType = 'success';
            this.selectAllUnusedNfes = false;
            this.selectedNfe = {};
            await this.fetchUnusedNfes();
          } else {
            this.errors = response.errors || ['Erro ao deletar NFes'];
            this.errorsType = 'error';
          }
        } else if (xmlIds.length > 0) {
          response = await this.deleteXmlNfe(xmlIds);

          if (response.success) {
            this.errors = ['XMLs deletados com sucesso!'];
            this.errorsType = 'success';
            this.selectAllXmlNfe = false;
            this.selectedXmlNfe = {};
            await this.fetchAllXmlNfe();
          } else {
            this.errors = response.errors || ['Erro ao deletar XMLs'];
            this.errorsType = 'error';
          }
        }
        this.selectedNfeNumbers = [];
        this.selectAllXmlNfe = false;
        await this.fetchQuantityXmlsNfe();
        this.checkAndEmit();
        this.checkBatchDelete();
      } catch (error) {
        console.error(error);
      } finally {
        this.isDeleteConfirmOpen = false;
        this.isDeleteButtonLoading = false;
      }
      this.$emit('cancelClick');
    },
    async selectCardStatus(index, card) {
      await this.setFilterStatusId(card.id);
      this.selectedCard = index;
      this.page = 1;
      if (this.paginate.totalRecords === 0) {
        await this.setFilterStatusId(null);
        await this.fetchAllXmlNfe();
        this.selectedCard = 0;
      }
      await this.checkAndEmit();
    },
    checkAndEmit() {
      const errorLength =
        this.filterByCardStatus.some((item) => item.status === 'successfulImports' && item.count > 0) ||
        this.selectedNfeIds.length > 0;
      const errorProcess = this.filterByCardStatus.some((item) => item.status === 'importsInProcess' && item.count > 0);
      let message = '';
      let errorValidate = false;
      if (this.totalNfes > 0 && this.totalNfesImport === 0) {
        message = '';
        errorValidate = false;
      } else if (!errorLength) {
        message = 'Selecione a(s) Nfe para Importação';
        errorValidate = true;
      } else if (errorProcess) {
        message = 'Aguarde o processamento da importação das Nfes';
        errorValidate = true;
      }
      this.$emit('step1Finished', errorValidate, message);
    },
    checkBatchDelete() {
      let message = '';
      let errorValidate = false;
      if (this.canSelectAllXmlNfe.length === 0 && this.filteredUnusedNfes.length === 0) {
        message = 'Nenhum Xml de Nfe disponível para descartar';
        errorValidate = true;
      } else if (this.selectedXmlNfeIds.length === 0 && this.selectedNfeIds.length === 0) {
        message = 'Selecione as Nfes para descartar';
        errorValidate = true;
      } else {
        errorValidate = false;
      }
      this.$emit('isBatchDeleteNfes', errorValidate, message);
    },
    transformCpfOrCnpj(str) {
      if (str.length === 11) {
        return maskCPF(str);
      }

      return maskCNPJ(str);
    }
  }
};
</script>

<style lang="scss" scoped>
.list-container {
  width: 100%;
  height: 638px;
  overflow: visible;
}

.selected-container {
  width: 100%;
  height: 88px;
  background-color: #e4e4e4;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  gap: 1rem;
  width: 100%;
}

.v-card-text-nfe,
.v-card-text-nfe h4,
.v-card-text-nfe .v-icon,
.v-card-text-nfe .row,
.v-card-text-nfe .col {
  transition: 2ms;
}

.v-card-text-nfe {
  cursor: pointer;
  width: auto;
  height: 42px;
  border: solid 1px #999999;
  white-space: nowrap;
}

.v-card-text-nfe h4 {
  font-size: 1.8rem;
  color: #000000;
}

.v-card-text-nfe:hover {
  border: solid 1px #4299e1;
  color: #4299e1;
}

.v-card-text-nfe:hover h4,
.v-card-text-nfe:hover .v-icon path {
  color: #4299e1;
  fill: #4299e1;
}

.selected-card {
  box-shadow: 0 2px 4px rgba(23, 23, 23, 0.18);
  border: solid 1px #4299e1;
  color: #4299e1;
  h4,
  .v-icon path {
    color: #4299e1;
    fill: #4299e1;
  }
}
.column-title {
  width: 100%;
  text-align: left;
}

.nfes-container {
  width: 100%;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.table-container {
  width: 100%;
  max-height: 630px;
  height: auto;
  overflow-y: auto;
  overflow-x: hidden;
}
.nfes-container::-webkit-scrollbar,
.table-container::-webkit-scrollbar {
  width: 8px;
  height: 5px;
  background-color: #f5f5f5;
}

.nfes-container::-webkit-scrollbar-track,
.table-container::-webkit-scrollbar-track {
  padding-left: 1px;
  padding-right: 1px;
  background-color: #f5f5f5;
}

.nfes-container::-webkit-scrollbar-thumb,
.table-container::-webkit-scrollbar-thumb {
  background-color: #999999;
  border-radius: 8px;
}
::v-deep .nfes-container::-webkit-scrollbar-thumb:hover,
.table-container::-webkit-scrollbar-thumb:hover {
  background-color: #0f426e9d;
}
.ghost-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.icon {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
.new-import-nfe {
  color: #000000;
}
::v-deep .custom-checkbox {
  margin-top: 0px;
  .v-label {
    font-weight: 500;
    font-size: 14px;
    color: black;
  }
}
::v-deep .v-input {
  input {
    max-height: 40px;
    .v-input__slot .v-input__prepend-inner {
      position: relative;
      top: 0px;
    }
  }
  .v-text-field {
    &__slot {
      margin: 0;
      padding: 0;

      input,
      textarea {
        border: none;
        border-radius: none;
        padding: 0 0px;
        box-shadow: none;
        background: none;

        &:focus,
        &:hover {
          background: none;
          border-color: none;
        }
      }

      .v-label {
        position: relative;
        transform: translateY(0px);
        top: auto;
        color: black;
      }
    }
  }
}
::v-deep .custom-checkbox .collapsed .v-input--selection-controls__input {
  margin-right: 0px;
}
</style>
